module.exports = __webpack_public_path__ + "images/9d407c0549bf4de4cb7bccd18e274003.svg";